import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence, useReducedMotion } from 'framer-motion';

/** Everything you can do here. Just the words. */
const WORDS = ['Catering', 'Frukost', 'Fika', 'Lunch', 'Buffé', 'Tårta', 'Mingelmat', 'Kaffe', 'Dryck', 'Bakverk', 'Presentlådor', 'Guider', 'Betyg', 'Tips', 'Upptäcka', 'Handla', 'Beställa'];
export function DoingWords() {
  const [index, setIndex] = useState(0);
  const reduced = useReducedMotion();
  useEffect(() => {
    if (reduced) return;
    const id = window.setInterval(() => setIndex(i => (i + 1) % WORDS.length), 1600);
    return () => window.clearInterval(id);
  }, [reduced]);
  return <p className="flex items-baseline gap-x-3 font-hand text-4xl leading-none sm:text-5xl" aria-label={`${WORDS.join(', ')} — i Småland`} data-id="element-524" data-mp="2art0fvavz727">
      <span className="relative inline-flex overflow-hidden py-1 text-rod" aria-hidden="true" data-id="element-525" data-mp="13bd96ec8gfzl">
        <AnimatePresence mode="popLayout" initial={false} data-id="element-526" data-mp="zdz1ir47ag9p">
          <motion.span key={WORDS[index]} layout initial={reduced ? false : {
          opacity: 0,
          y: '60%',
          rotate: -2
        }} animate={{
          opacity: 1,
          y: 0,
          rotate: 0
        }} exit={reduced ? undefined : {
          opacity: 0,
          y: '-60%',
          rotate: 2
        }} transition={{
          duration: 0.24,
          ease: [0.23, 1, 0.32, 1]
        }} className="block whitespace-nowrap" data-id="element-527" data-mp="kctam5j5k9us">
            {WORDS[index]}
          </motion.span>
        </AnimatePresence>
      </span>

      <motion.span layout transition={{
      duration: 0.24,
      ease: [0.23, 1, 0.32, 1]
    }} aria-hidden="true" className="whitespace-nowrap text-black/40" data-id="element-528" data-mp="6d1xs84dgzid">
        i Småland
      </motion.span>
    </p>;
}